import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Form, Formik, FieldArray } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Dropzone from "react-dropzone";
import * as Yup from "yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Select from "react-select";
import ProfileImage from "components/profileImage";
import formatBytes from "utils/formatBytes";
import getImageUrl from "utils/getImageUrl";
import { CreateBlogPost, UpdateBlogPost } from "services/V2_APIs/blog.service";
import SweetAlert from "react-bootstrap-sweetalert";
import Spinner from "components/spinner";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  content: Yup.string().required("Content is required"),
  descriptions: Yup.array().of(
    Yup.object().shape({
      heading: Yup.string().required("Heading is required"),
      shortDescription: Yup.string().required("Description is required"),
    })
  ),
});
const modules = {
  toolbar: {
    container: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      ["link", "image"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ indent: "-1" }, { indent: "+1" }],
      ["clean"],
    ],
    handlers: {
      // Ensures editor stays focused after clicking toolbar buttons
      bold: function () {
        this.quill.format("bold", !this.quill.getFormat().bold);
        this.quill.focus();
      },
      italic: function () {
        this.quill.format("italic", !this.quill.getFormat().italic);
        this.quill.focus();
      },
      underline: function () {
        this.quill.format("underline", !this.quill.getFormat().underline);
        this.quill.focus();
      },
      // ... Add more handlers as needed
    },
  },
};

export const CreateBlog = ({ toggle, modal, id, reload,handleActiveOrder }) => {
  const quillRef = useRef(null);
  const longDescriptionHeadingRef = useRef(null);
  const longDescriptionContentRef = useRef(null);
  const rightSideWebContentHeadingRef = useRef(null);
  const rightSideWebContentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [webpageBanner, setWebpageBanner] = useState();
  const [mobilebanner, setMobilebanner] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [customColor, setCustomColor] = useState("#000000");
  const [longDescriptionContentColor, setLongDescriptionContentColor] =
    useState("#000000");
  const [longDescriptionHeadingColor, setLongDescriptionHeadingColor] =
    useState("#000000");
  const [rightSideWebContentHeadingColor, setRightSideWebContentHeadingColor] =
    useState("#000000");
  const [rightSideWebContentColor, setRightSideWebContentContentColor] =
    useState("#000000");
  const defaultValues = {
    title: "",
    shortDescription: "",
    // category: "",
    webBanner: "",
    mobileBanner: "",
    backgroundColorCode: "",
    userName: "StylifyIndia",
    role: "Author",
    isPublished: false,
    isActive: false,
    created_at: new Date(),
    content: [{ title: "", description: "" }],
    rightSideWebContent: [{ heading: "", content: "" }],
    publishedDate: "",
    // Images: [],
    // userId:"",
    // comments:[],
    // likes:[]
  };
  const initialValues = id ? { ...defaultValues, ...id } : defaultValues;
  const leaveToList = () => {
    toggle();
    setsuccess_msg(false);
    seterror_msg(false);
    setMobilebanner("");
    setWebpageBanner("");
    setSelectedDate("");
  };
  const onCancel = () => {
    setMobilebanner("");
    setWebpageBanner("");
    setSelectedDate("");
  };
  const onSubmit = values => {
    if (id) {
      editChanges(values);
    } else {
      saveChanges(values);
    }
  };
  const saveChanges = values => {
    let payload = {
      ...values,
      webBanner: webpageBanner,
      mobileBanner: mobilebanner,
      publishedDate: selectedDate,
    };
    console.log(payload, "payload blog");
    setLoading(true);
    CreateBlogPost(payload)
      .then(res => {
        if (res?.success) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload();
        handleActiveOrder()
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };
  const editChanges = values => {
    let payload = {
      ...values,
      webBanner: webpageBanner,
      mobileBanner: mobilebanner,
      publishedDate: selectedDate,
    };
    console.log(payload, "payload blog");
    setLoading(true);
    UpdateBlogPost(id?._id, payload)
      .then(res => {
        if (res?.success) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload();
        handleActiveOrder()
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };
  const successPopup = () => {
    return (
      <SweetAlert
        title="Success"
        success
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Ok
            </Button>
          </React.Fragment>
        }
      >
        {id ? " Successfully Blog Edited" : " Successfully Blog Created"}
      </SweetAlert>
    );
  };

  const errorPopup = () => {
    return (
      <SweetAlert
        title="Failure"
        danger
        onConfirm={leaveToList}
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Ok
            </Button>
          </React.Fragment>
        }
      >
        Something went wrong
      </SweetAlert>
    );
  };

  const applyCustomColor = () => {
    const editor = quillRef.current?.getEditor();
    if (editor) {
      editor.format("color", customColor);
      editor.focus();
    }
  };
  const applyCustomColorForLongDescriptionHeading = () => {
    const editor = longDescriptionHeadingRef.current?.getEditor();
    if (editor) {
      editor.format("color", longDescriptionHeadingColor);
      editor.focus();
    }
  };
  const applyCustomColorForLongDescriptionContent = () => {
    const editor = longDescriptionContentRef.current?.getEditor();
    if (editor) {
      editor.format("color", longDescriptionContentColor);
      editor.focus();
    }
  };
  const applyCustomColorForRightsideWebContent = () => {
    const editor = rightSideWebContentRef.current?.getEditor();
    if (editor) {
      editor.format("color", rightSideWebContentColor);
      editor.focus();
    }
  };
  const applyCustomColorForRightsideWebHeading = () => {
    const editor = rightSideWebContentHeadingRef.current?.getEditor();
    if (editor) {
      editor.format("color", rightSideWebContentHeadingColor);
      editor.focus();
    }
  };
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        size="xl"
        onClosed={() => {
          onCancel();
        }}
      >
        <ModalHeader toggle={toggle}>
          {id ? "Edit Blog" : "Create Blog"}
        </ModalHeader>
        <ModalBody className="bg-light">
          <Container fluid>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              // onSubmit={onSubmit}
            >
              {({ values, handleChange, setFieldValue }) => {
                useEffect(() => {
                  if (id) {
                    setMobilebanner(id?.mobileBanner);
                    setWebpageBanner(id?.webBanner);
                    setSelectedDate(id?.publishedDate || "");
                  }
                }, [id]);
                return (
                  <Form>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="title">Title</Label>
                          <Input
                            type="text"
                            name="title"
                            id="title"
                            value={values.title}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={4}>
                        <FormGroup className="form_group">
                          <Label for="publishedDate">publish Date</Label>
                          <DatePicker
                            name="publishedDate"
                            dateFormat="dd-MMM-yyyy"
                            className="form-control"
                            selected={
                              selectedDate ? new Date(selectedDate) : null
                            }
                            onChange={date => setSelectedDate(date)}
                            dropdownMode="select"
                            showIcon
                            toggleCalendarOnIconClick
                            adjustDateOnChange
                            autoComplete="off"
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        md={2}
                        className="d-flex align-items-center flex-wrap"
                      >
                        <Label className="form-label d-block mb-1 me-2">
                          Publish Blog
                        </Label>
                        <Switch
                          onChange={val => setFieldValue("isPublished", val)}
                          checked={values.isPublished}
                          onColor="#86d3ff"
                          onHandleColor="#2693e6"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 2px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={15}
                          width={40}
                          className="react-switch"
                          id="is_published_switch"
                        />
                      </Col>

                      <Col
                        md={3}
                        className="d-flex align-items-center flex-wrap"
                      >
                        <Label className="form-label d-block mb-1 me-2">
                          Active
                        </Label>
                        <Switch
                          onChange={val => setFieldValue("isActive", val)}
                          checked={values.isActive}
                          onColor="#86d3ff"
                          onHandleColor="#2693e6"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 2px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={15}
                          width={40}
                          className="react-switch"
                          id="is_active_switch"
                        />
                      </Col>
                    </Row>

                    <div className="d-flex align-items-center">
                      <Label className="me-2">Short Description</Label>
                      <div className="px-2 mb-2">
                        <span>|</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <label>Custom Text Color:</label>
                        <input
                          type="color"
                          value={customColor}
                          onChange={e => setCustomColor(e.target.value)}
                        />
                        <Button
                          type="button"
                          color="primary"
                          onClick={applyCustomColor}
                        >
                          Apply Color
                        </Button>
                      </div>
                    </div>
                    <Card>
                      <div className="mt-3">
                        <ReactQuill
                          ref={quillRef}
                          theme="snow"
                          value={values?.shortDescription}
                          onChange={value => {
                            setFieldValue("shortDescription", value);
                          }}
                          modules={modules}
                        />
                      </div>
                    </Card>
                    <Label className="">Long Description</Label>
                    <FieldArray name="content">
                      {({ push, remove }) => (
                        <div>
                          <Button
                            color="primary"
                            className="mt-2 mb-3"
                            onClick={() => push({ title: "", description: "" })}
                          >
                            Add Description
                          </Button>
                          {values.content.map((desc, index) => (
                            <Card
                              key={index}
                              className="p-3 mb-3 position-relative"
                            >
                              <Row>
                                <Col
                                  md={12}
                                  className="d-flex justify-content-between align-items-center"
                                >
                                  <FormGroup className="w-70">
                                    <div className="d-flex align-items-center">
                                      <Label className="me-2">Heading</Label>

                                      <div className="px-2 mb-2">
                                        <span>|</span>
                                      </div>
                                      <div
                                        style={{
                                          // marginTop: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <label>Custom Text Color:</label>
                                        <input
                                          type="color"
                                          value={longDescriptionHeadingColor}
                                          onChange={e =>
                                            setLongDescriptionHeadingColor(
                                              e.target.value
                                            )
                                          }
                                        />
                                        <Button
                                          type="button"
                                          color="primary"
                                          onClick={
                                            applyCustomColorForLongDescriptionHeading
                                          }
                                        >
                                          Apply Color
                                        </Button>
                                      </div>
                                    </div>
                                    <ReactQuill
                                      ref={longDescriptionHeadingRef}
                                      theme="snow"
                                      value={desc?.title}
                                      onChange={content =>
                                        setFieldValue(
                                          `content.${index}.title`,
                                          content
                                        )
                                      }
                                      modules={modules}
                                    />
                                  </FormGroup>
                                  <div>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      className=""
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <FormGroup>
                                  <div className="d-flex align-items-center">
                                      <Label className="me-2">Content</Label>

                                      <div className="px-2 mb-2">
                                        <span>|</span>
                                      </div>
                                      <div
                                        style={{
                                          // marginTop: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <label>Custom Text Color:</label>
                                        <input
                                          type="color"
                                          value={longDescriptionContentColor}
                                          onChange={e =>
                                            setLongDescriptionContentColor(
                                              e.target.value
                                            )
                                          }
                                        />
                                        <Button
                                          type="button"
                                          color="primary"
                                          onClick={
                                            applyCustomColorForLongDescriptionContent
                                          }
                                        >
                                          Apply Color
                                        </Button>
                                      </div>
                                    </div>
                                    <ReactQuill
                                    ref={longDescriptionContentRef}
                                      theme="snow"
                                      value={desc.description}
                                      onChange={content =>
                                        setFieldValue(
                                          `content.${index}.description`,
                                          content
                                        )
                                      }
                                      modules={modules}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Card>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                    <h6>
                      Right side content (<i>for web only</i>)
                    </h6>
                    <Card>
                      <CardBody>
                        <Col md={4}>
                          <FormGroup>
                            <Label for="backgroundColorCode">
                              Background color code
                            </Label>
                            <Input
                              type="text"
                              name="backgroundColorCode"
                              id="backgroundColorCode"
                              value={values.backgroundColorCode}
                              onChange={handleChange}
                              placeholder="#ef4354"
                            />
                          </FormGroup>
                        </Col>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody className="p-1">
                        <FieldArray name="rightSideWebContent">
                          {({ push, remove }) => (
                            <>
                              {values.rightSideWebContent.map((item, index) => (
                                <Card key={index}>
                                  <CardBody>
                                    <FormGroup>
                                    <div className="d-flex align-items-center">
                                      <Label className="me-2">Heading</Label>

                                      <div className="px-2 mb-2">
                                        <span>|</span>
                                      </div>
                                      <div
                                        style={{
                                          // marginTop: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <label>Custom Text Color:</label>
                                        <input
                                          type="color"
                                          value={rightSideWebContentHeadingColor}
                                          onChange={e =>
                                            setRightSideWebContentHeadingColor(
                                              e.target.value
                                            )
                                          }
                                        />
                                        <Button
                                          type="button"
                                          color="primary"
                                          onClick={
                                            applyCustomColorForRightsideWebHeading
                                          }
                                        >
                                          Apply Color
                                        </Button>
                                      </div>
                                    </div>
                                      <ReactQuill
                                      ref={rightSideWebContentHeadingRef}
                                        theme="snow"
                                        value={item.heading}
                                        onChange={content =>
                                          setFieldValue(
                                            `rightSideWebContent.${index}.heading`,
                                            content
                                          )
                                        }
                                        modules={modules}
                                      />
                                    </FormGroup>
                                    <div className="d-flex align-items-center">
                                      <Label className="me-2">Content</Label>

                                      <div className="px-2 mb-2">
                                        <span>|</span>
                                      </div>
                                      <div
                                        style={{
                                          // marginTop: "10px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <label>Custom Text Color:</label>
                                        <input
                                          type="color"
                                          value={rightSideWebContentColor}
                                          onChange={e =>
                                            setRightSideWebContentContentColor(
                                              e.target.value
                                            )
                                          }
                                        />
                                        <Button
                                          type="button"
                                          color="primary"
                                          onClick={
                                            applyCustomColorForRightsideWebContent
                                          }
                                        >
                                          Apply Color
                                        </Button>
                                      </div>
                                    </div>
                                    <ReactQuill
                                    ref={rightSideWebContentRef}
                                      theme="snow"
                                      value={item?.content}
                                      onChange={content =>
                                        setFieldValue(
                                          `rightSideWebContent.${index}.content`,
                                          content
                                        )
                                      }
                                      modules={modules}
                                    />
                                    {/* <Button
                                    color="danger"
                                    size="sm"
                                    className="mt-2"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </Button> */}
                                  </CardBody>
                                </Card>
                              ))}
                              {/* <Button
                              color="primary"
                              className="mt-3"
                              onClick={() => push({ heading: "", content: "" })}
                            >
                              Add Right Side Content
                            </Button> */}
                            </>
                          )}
                        </FieldArray>
                      </CardBody>
                    </Card>
                    <Row>
                      {[
                        {
                          label: "Web Page Banner",
                          state: webpageBanner,
                          setState: setWebpageBanner,
                        },
                        {
                          label: "Mobile Banner",
                          state: mobilebanner,
                          setState: setMobilebanner,
                        },
                      ].map(({ label, state, setState }, index) => (
                        <Col md={6} key={index} className="mt-3">
                          <FormGroup>
                            <Label>{label}</Label>
                            <Dropzone
                              onDrop={async acceptedFiles => {
                                const imgUrl = await getImageUrl({
                                  image: acceptedFiles,
                                });
                                setState(imgUrl);
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone image_drop border rounded p-3 text-center">
                                  <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <i className="display-6 text-muted bx bxs-cloud-upload" />
                                    <h6>Drop files here or click to upload.</h6>
                                  </div>
                                </div>
                              )}
                            </Dropzone>

                            {state && (
                              <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <ProfileImage
                                        image={state}
                                        height="80"
                                        classNames="avatar-sm rounded bg-light"
                                      />
                                    </Col>
                                    <Col>
                                      <Button
                                        color="danger"
                                        size="sm"
                                        onClick={() => setState(null)}
                                      >
                                        Remove
                                      </Button>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )}
                          </FormGroup>
                        </Col>
                      ))}
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                      <Button color="light" className="me-3" onClick={toggle}>
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        type="submit"
                        onClick={() => {
                          onSubmit(values);
                        }}
                      >
                        {id ? "Save Changes" : "Submit"}
                      </Button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Container>
        </ModalBody>
      </Modal>
      <Spinner loading={loading} />
      {success_msg ? successPopup() : null}
      {error_msg ? errorPopup() : null}
    </>
  );
};

export default CreateBlog;
